export default "__VITE_ASSET__BVJPSnpk__"